module.exports = __webpack_public_path__ + "img/ad.b0564608.png";